import logger from '../utils/rbata.logger';

const trackingProductTile = {
    trackProductImpression(trackingData) { // ATM used for CDS slider tiles only
        const trackingJson = JSON.parse(trackingData.trackingJson.replace(/'/g, '"'));

        window.dataLayer.push({
            'event':     'EECproductImpressions',
            'ecommerce': {
                'currencyCode': trackingData.currencyCode,
                impressions:    [
                    {
                        'name':     trackingJson.name,
                        'id':       trackingJson.baseId ? trackingJson.baseId : trackingJson.id,
                        'item_variant': trackingJson.id,
                        'item_color': trackingJson.color,
                        'item_size': trackingJson.size,
                        'price':    trackingJson.price.toString(),
                        'brand':    trackingJson.brand,
                        'list':     trackingData.listingType + '_' + alphatauri.util.lowercaseFirstLetter(trackingData.listingName),
                        'category': trackingJson.gtmGender + '/' + trackingJson.categoryName,
                        'position': parseInt(trackingData.position, 10)
                    }
                ]
            }
        });
        window.dataLayer.push({
            event:     'view_item_list',
            ecommerce: {
                currency: trackingData.currencyCode,
                items:    [
                    {
                        'item_name':      trackingJson.name,
                        'item_id':        trackingJson.baseId ? trackingJson.baseId : trackingJson.id,
                        'item_variant':   trackingJson.id,
                        'item_color':     trackingJson.color,
                        'item_size':      trackingJson.size,
                        'price':          trackingJson.price.toString(),
                        'item_brand':     trackingJson.brand,
                        'item_category':  trackingJson.gtmGender + '/' + trackingJson.categoryName,
                        'item_category2': trackingJson.category2 ? trackingJson.category2 : "",
                        'item_list_name': alphatauri.util.lowercaseFirstLetter(trackingData.listingName),
                        'item_list_id':   trackingData.listingType,
                        'index':          parseInt(trackingData.position, 10),
                        'quantity':       1
                    }
                ]
            }
        });
    },

    trackProductClick(trackingData) {
        const trackingJson = JSON.parse(trackingData.trackingJson.replace(/'/g, '"'));
        dataLayer.push({
            'event':         'EECproductClick',
            'ecommerce':     {
                'click': {
                    'actionField': {
                        'list': `${trackingData.listingType}_${trackingData.listingName}`
                    },
                    'products':    [{
                        'name':     trackingJson.name,
                        'id':       trackingJson.baseId ? trackingJson.baseId : trackingJson.id,
                        'item_variant': trackingJson.id,
                        'item_color': trackingJson.color,
                        'item_size': trackingJson.size,
                        'price':    trackingJson.price !== undefined ? trackingJson.price.toString() : undefined,
                        'brand':    trackingJson.brand,
                        'category': `${trackingJson.gtmGender}/${trackingJson.categoryName}`,
                        'list':     `${trackingData.listingType}_${alphatauri.util.lowercaseFirstLetter(trackingData.listingName)}`,
                        'position': parseInt(trackingData.position, 10)
                    }]
                }
            }
        });
        dataLayer.push({
            event:     'select_item',
            ecommerce: {
                items: [{
                    'item_name':      trackingJson.name,
                    'item_id':        trackingJson.baseId ? trackingJson.baseId : trackingJson.id,
                    'item_variant':   trackingJson.id,
                    'item_color':     trackingJson.color,
                    'item_size':      trackingJson.size,
                    'price':          trackingJson.price !== undefined ? trackingJson.price.toString() : undefined,
                    'currency':       trackingJson.currencyCode,
                    'item_brand':     trackingJson.brand,
                    'item_category':  `${trackingJson.gtmGender}/${trackingJson.categoryName}`,
                    'item_category2': trackingJson.category2 ? trackingJson.category2 : "",
                    'item_list_name': alphatauri.util.lowercaseFirstLetter(trackingData.listingName),
                    'item_list_id':   trackingData.listingType,
                    'index':          parseInt(trackingData.position, 10),
                    'quantity':       1
                }]
            },
            'eventCallback': function () {
                document.location = trackingData.eventCallback
            },
            'eventTimeout':  2000
        });
    },
    bindProductClick() {
        $(document.body).on('click', '.js-tile-track', (evt) => {
            // https://www.simoahava.com/gtm-tips/use-eventtimeout-eventcallback/
            if (window['google_tag_manager']) {
                evt.preventDefault();
                this.trackProductClick(evt.currentTarget.dataset);
            } else {
                logger.debug('no GTM present');
            }
        });
    }
};

$(() => {
    trackingProductTile.bindProductClick();
});

export default trackingProductTile;
